import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import japanTwoTrainersData from '../data/JapanTwo';
import './JapanOne.css';

const JapanTwoTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(japanTwoTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('🇯🇵 Japan Two trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/japan-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/japan-train-categories');
    };

    return (
        <div className="japan-trainers-container">
            <div className="japan-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="japan-trainers-header">
                <div className="header-content">
                    <h1>Monks & Mountain Warriors</h1>
                    <p>Train with zen masters, giant ninjas, and sacred champions</p>
                    <div className="category-stats">
                        <span className="stat-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge">Category: Ancient Japan</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="japan-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="japan-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                        style={{
                            '--japan-primary-color': trainer.color,
                            '--japan-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Trainer Image */}
                        <div className="japan-trainer-image-section">
                            <div
                                className="japan-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="japan-mist-effect"></div>
                                <div className="experience-badge japan-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="japan-trainer-info-section">
                            <h3 className="japan-trainer-name">{trainer.name}</h3>
                            <p className="japan-trainer-specialization">{trainer.specialization}</p>
                            <p className="japan-trainer-description">{trainer.intro}</p>

                            <div className="japan-trainer-details">
                                <div className="detail-item japan-detail">
                                    <div className="detail-icon">⚔️</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item japan-detail">
                                    <div className="detail-icon">🧘</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="japan-trainers-footer">
                <div className="japan-info">
                    <h3>Monks & Mountain Warriors Philosophy</h3>
                    <div className="japan-benefits-grid">
                        <div className="japan-benefit-item">
                            <div className="benefit-icon">🧘</div>
                            <div>
                                <strong>Zen Enlightenment</strong>
                                <p>Perfect balance of mind, body, and spirit through meditation</p>
                            </div>
                        </div>
                        <div className="japan-benefit-item">
                            <div className="benefit-icon">🥷</div>
                            <div>
                                <strong>Giant Ninja Power</strong>
                                <p>Massive strength hidden within shadow arts and stealth</p>
                            </div>
                        </div>
                        <div className="japan-benefit-item">
                            <div className="benefit-icon">🏔️</div>
                            <div>
                                <strong>Mountain Mastery</strong>
                                <p>Elemental training that connects with natural forces</p>
                            </div>
                        </div>
                        <div className="japan-benefit-item">
                            <div className="benefit-icon">🏆</div>
                            <div>
                                <strong>Sacred Strength</strong>
                                <p>Spiritual purity combined with overwhelming physical power</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JapanTwoTrainers;